import { Card, Table, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";

import styles from "../index.module.less";
import Loading from "../../common/Loading";

import type { KeyFobData, parkingStatusCountInterface } from "../../../shared/interface/dashboard.interface";
import { General } from "../../../util/General";

interface OnGoingStatusCardProps {
  data: KeyFobData[];
  parkingStatusCount: parkingStatusCountInterface;
  loading: boolean;
  isFullScreen?: boolean;
}

const OnGoingStatusCard = (props: OnGoingStatusCardProps) => {
  const columns: ColumnsType<KeyFobData> = [
    {
      align: "center",
      title: "",
      key: "lift",
      dataIndex: "lift",
      render: (text) => <div>{text}</div>,
      width: "35%"
    },
    {
      align: "center",
      title: "Booking",
      key: "storage",
      dataIndex: "storage",
      render: (text) => <div>{text}</div>,
      onCell: () => ({
        className: styles["table-cell"]
      })
    },
    {
      align: "center",
      title: "Retrieving",
      key: "retrieving",
      dataIndex: "retrieving",
      render: (text) => <div>{text}</div>,
      onCell: () => ({
        className: styles["table-cell"]
      })
    }
  ];

  const renderUI = () => (
    <>
      <div className={props?.isFullScreen ? styles["card-header-full-screen"] : styles["card-header"]}>{"Ongoing Lift Status"}</div>
      {props?.loading ? (
        <Loading />
      ) : !props?.loading && props?.data?.length > 0 ? (
        <>
          <Table
            scroll={{ y: props?.isFullScreen ? "70vh" : "18vh" }}
            className={`gx-table-responsive`}
            columns={columns}
            dataSource={props.data}
            bordered
            rowKey="sr_no"
            pagination={false}
            size="small"
            components={{
              header: {
                cell: (props: React.HTMLProps<HTMLTableCellElement>) => <th {...props} className={`${props.className} ${styles["custom-table-header"]}`} />
              }
            }}
          />
        </>
      ) : (
        <svg width="100%">
          <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="h3">
            No data available!
          </text>
        </svg>
      )}
    </>
  );

  const renderParkingStatusCountUI = () => (
    <>
      {!props?.loading ? (
        <div className={styles["parking-status-count-container"]}>
          <Tag className={styles["parking-status-execution"]}>Execution: {General.numberWithCommas(props?.parkingStatusCount?.executionCount ?? 0)}</Tag>
          <Tag className={styles["parking-status-waiting"]}>Waiting: {General.numberWithCommas(props?.parkingStatusCount?.waitingCount ?? 0)}</Tag>
        </div>
      ) : null}
    </>
  );

  return props?.isFullScreen ? (
    <div className="gx-text-center gx-p-2">
      {renderUI()}
      {renderParkingStatusCountUI()}
    </div>
  ) : (
    <Card title={null} bodyStyle={{ padding: "15px" }} className={`gx-card gx-text-center ${styles["card-container"]}`}>
      {renderUI()}
      {renderParkingStatusCountUI()}
    </Card>
  );
};

export default OnGoingStatusCard;
